// import Swiper JS
import Swiper from 'swiper/bundle';

(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.nodeHeroSwiper = {
    attach: function attach(context) {

      // Set default swiper options.
      let swiperOptions = {
        spaceBetween: 22,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: ".promo-hero__swiper-pagination",
          clickable: true,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: Drupal.t('Gå till föregående'),
          nextSlideMessage: Drupal.t('Gå till nästa'),
        }
      };

      // Get the delay setting from the landing page node in milliseconds.
      let swiperDelay = drupalSettings.khstSwiperDelay;

      // If swiper delay, we turn it on  by adding "autoplay"swiperDelay to the swiper conf before creating the swiper.
      if (swiperDelay !== "undefined" && swiperDelay > 0) {
        swiperOptions.autoplay = {
          delay: swiperDelay,
          disableOnInteraction: true,
        }
      }

      // Create the swiper.
      const heroSwiper = new Swiper('.promo-hero__swiper', swiperOptions);
    }
  };
})(jQuery, Drupal, drupalSettings);
